export type AccessMode = "password" | "link_only" | "password_or_link";
export type PlaybackSource = "mux_api" | "curated";

export type PrivateReelsConfig = {
  enabled: boolean;
  access_mode: AccessMode;
  has_password: boolean;
  playback_source: PlaybackSource;
  curated_playback_ids: string[];
  max_videos_in_feed: number;
  max_views_per_session: number;
};

export type PrivateReelsShareLink = {
  id: string;
  token: string;
  url: string;
  label: string | null;
  expires_at: string;
  max_uses: number;
  uses_count: number;
  last_used_at: string | null;
  status: string;
};

export const REELS_SUBNAV = [
  {
    to: "/admin/reels",
    end: true,
    label: "Resumen",
    description: "Estado del feed",
  },
  {
    to: "/admin/reels/videos",
    end: false,
    label: "Videos",
    description: "Upload + playlist",
  },
  {
    to: "/admin/reels/acceso",
    end: false,
    label: "Acceso",
    description: "Password y límites",
  },
  {
    to: "/admin/reels/links",
    end: false,
    label: "Links multi-uso",
    description: "TTL y usos",
  },
  {
    to: "/admin/reels/secret-share",
    end: false,
    label: "Secret share",
    description: "Link que se quema",
  },
] as const;
